/**
 * Shared styling constants for predictions to ensure visual consistency
 */
export const predictionStyles = {
  // Text styling
  font: {
    size: '10px',
    family: 'sans-serif',
    labelOffset: 15,
  },
  
  // Colors (with transparency)
  colors: {
    success: 'rgba(46, 204, 113, 0.9)',  // Brighter green
    successSolid: 'rgba(46, 204, 113, 1)',
    successBright: 'rgba(39, 174, 96, 1)', // Even brighter for emphasis
    failed: 'rgba(231, 76, 60, 0.9)',    // Brighter red  
    failedSolid: 'rgba(231, 76, 60, 1)',
    failedBright: 'rgba(192, 57, 43, 1)', // Even brighter red for emphasis
    pending: 'rgba(255, 152, 0, 0.9)',  // Orange
    pendingSolid: 'rgba(255, 152, 0, 1)',
    // Bet-specific colors
    betWinner: 'rgba(255, 215, 0, 0.9)',  // Gold for bet winner
    betWinnerSolid: 'rgba(255, 215, 0, 1)',
    betLoser: 'rgba(169, 169, 169, 0.9)',  // Silver/gray for bet loser  
    betLoserSolid: 'rgba(169, 169, 169, 1)',
  },
  
  // Line styling
  line: {
    dashPattern: '4,3',
    width: 3, // Increased from 2 to 3 for better visibility
    markerWidth: 2, // Increased from 1.5 to 2
  },
  
  // Circle styling
  circle: {
    radius: {
      large: 8,  // Increased from 6 to 8
      small: 5,  // Increased from 4 to 5
      extraLarge: 10 // Added for status indicators
    },
    strokeWidth: 2.5, // Increased from 1.5 to 2.5
    stroke: 'white',
  },
  
  // Status indicator styling
  statusIndicators: {
    success: {
      symbol: '✓',
      fontSize: '14px',
      color: 'rgba(46, 204, 113, 1)',
      backgroundColor: 'white',
      borderRadius: '50%',
      padding: '3px',
    },
    miss: {
      symbol: '✗',
      fontSize: '14px', 
      color: 'rgba(231, 76, 60, 1)',
      backgroundColor: 'white',
      borderRadius: '50%',
      padding: '3px',
    }
  }
};
